import { ChakraFlex, MaudSectionHeader } from '@equip.health/ui';

import { PatientEvents } from '~/analytics/patientEvents';
import {
  initialBillingPeriodState,
  useBillingPeriod,
} from '~/components/common/billingPeriods/useBillingPeriod';
import { BILLING_PERIODS_TOP_LEVEL_ID } from '~/lib/constants';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import {
  PortalComponent,
  useComponentPortalContext,
} from '~/lib/contexts/ComponentPortalContext';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';
import { useGetPatientBillingPeriodsQuery } from '~/store/services/clinicalData';

import BillingPeriodsList from './BillingPeriodsList';

type BillingPeriodsProps = {
  isCarePlanPermissionsEnabled: boolean;
};
const BillingPeriods = ({
  isCarePlanPermissionsEnabled,
}: BillingPeriodsProps) => {
  const { currentPatientId } = useGlobalContext();
  const { setComponentVisibility } = useComponentPortalContext();
  const { resetBillingPeriodState } = useBillingPeriod();

  const { data: billingPeriods, isLoading: isGetBillingPeriodsLoading } =
    useGetPatientBillingPeriodsQuery(currentPatientId, {
      skip: !currentPatientId,
    });

  const { trackEvent } = useAnalytics();

  const handleAddBillingPeriod = () => {
    trackEvent(PatientEvents.addBillingPeriodProfileTabButtonClicked, {
      Source: AnalyticsSourceValues.PATIENT_TAB,
    });
    resetBillingPeriodState();
    setComponentVisibility({
      component: PortalComponent.BILLING_PERIOD_ACCORDION,
      data: initialBillingPeriodState,
      isExpanded: true,
      isVisible: true,
    });
  };

  return (
    <ChakraFlex
      as="section"
      flexDirection="column"
      gridGap="24px"
      id={`${BILLING_PERIODS_TOP_LEVEL_ID}__section`}
      marginBottom="40px"
      marginTop="40px"
      width="100%"
    >
      <MaudSectionHeader
        count={billingPeriods?.data?.length}
        id={`${BILLING_PERIODS_TOP_LEVEL_ID}__header`}
        onAdd={isCarePlanPermissionsEnabled && handleAddBillingPeriod}
        onAddTitle="Add billing period"
        style="secondary"
        title="Billing periods"
      />

      <BillingPeriodsList
        billingPeriods={billingPeriods?.data}
        isLoading={isGetBillingPeriodsLoading}
      />
    </ChakraFlex>
  );
};

export default BillingPeriods;
